import { getUsernameColorClass } from "../../utils/css/user"
import type { IUserInfo } from "@multimediallc/web-utils/types"

type ClassValue =
    | string
    | null
    | undefined
    | false
    | Record<string, boolean>
    | ClassValue[]

export const classNames = (...args: ClassValue[]): string => {
    return args
        .flatMap((arg) => {
            if (typeof arg === "string") {
                return arg
            }
            if (Array.isArray(arg)) {
                return classNames(...arg)
            }
            if (typeof arg === "object" && arg !== null) {
                return Object.keys(arg).filter((key) => arg[key])
            }
            return []
        })
        .join(" ")
}

/**
 * Handles navigation to a user's profile page
 */
export const handleProfileNavigation = ({
    username,
    isDesktop,
}: {
    username: string
    isDesktop: boolean
}): void => {
    const profileUrl = `/${username}/`

    if (isDesktop) {
        window.open(profileUrl, "_blank")
    } else {
        window.location.href = profileUrl
    }
}

const setBroadcasterFromPath = (user: IUserInfo): IUserInfo => {
    const pathname = window.location.pathname.split("/")
    const isBroadcaster = pathname[1] === user.username

    return {
        ...user,
        isBroadcaster,
    }
}

/**
 * Determines the appropriate color class for a user's username,
 * factoring in whether the user is a broadcaster based on the current URL path.
 *
 * This function checks if the user is the broadcaster by comparing the
 * first segment of the current pathname to the user's username.
 *
 * @param {IUserInfo} user - The user object to resolve the color class for.
 * @returns {string} - The CSS class name representing the user's display color.
 */
export const resolveUserColorClass = (user: IUserInfo): string => {
    const u = setBroadcasterFromPath(user)
    return getUsernameColorClass(u)
}
